import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  margin-right: 12px;\n\n  @media screen and (max-width: ", "px) {\n    width: 50%;\n    display: flex;\n    justify-content: center;\n    margin-right: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import posed from 'react-pose';
import { equals } from 'ramda';
import { compose, defaultProps, withHandlers, withState } from 'recompose';
import styled from '../utils/styling/styled-components';
import { withClickOutside } from '../HOCs/withClickOutside';
import { theme } from '../theme';
import { DropdownButton } from './DropdownButton';
import { DropdownItem } from './DropdownItem';
import { DropdownMenu } from './DropdownMenu';
import { ResponsiveMenu } from './ResponsiveMenu';
var Container = styled.div(_templateObject(), function (props) {
  return props.theme.breakpoints.md;
});
var FadeIn = posed.div({
  enter: {
    opacity: 1,
    applyAtStart: {
      display: 'block'
    }
  },
  exit: {
    opacity: 0,
    applyAtEnd: {
      display: 'none'
    }
  }
});
var enhance = compose(defaultProps({
  loading: false
}), withState('isOpen', 'setIsOpen', false), withHandlers({
  toggleDropdown: function toggleDropdown(_ref) {
    var isOpen = _ref.isOpen,
        setIsOpen = _ref.setIsOpen;
    return function () {
      return setIsOpen(!isOpen);
    };
  },
  handleItemClick: function handleItemClick(_ref2) {
    var onClick = _ref2.onClick,
        setIsOpen = _ref2.setIsOpen;
    return function (option) {
      return function () {
        if (onClick) {
          onClick(option);
        }

        setIsOpen(false);
      };
    };
  }
}), withClickOutside(function (_ref3) {
  var setIsOpen = _ref3.setIsOpen;
  return setIsOpen(false);
}));

var DropdownComponent = function DropdownComponent(_ref4) {
  var handleItemClick = _ref4.handleItemClick,
      isOpen = _ref4.isOpen,
      loading = _ref4.loading,
      options = _ref4.options,
      _ref4$selectedOption = _ref4.selectedOption,
      selectedOption = _ref4$selectedOption === void 0 ? '' : _ref4$selectedOption,
      toggleDropdown = _ref4.toggleDropdown,
      testId = _ref4['data-testid'],
      className = _ref4.className,
      _ref4$hasArrow = _ref4.hasArrow,
      hasArrow = _ref4$hasArrow === void 0 ? true : _ref4$hasArrow;
  var responsive = window.matchMedia("(max-width: ".concat(theme.breakpoints.md, "px)")).matches;
  var Menu = responsive ? ResponsiveMenu : DropdownMenu;
  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": testId,
    className: className
  }, /*#__PURE__*/React.createElement(DropdownButton, {
    isOpen: isOpen,
    label: selectedOption,
    loading: loading,
    onClick: toggleDropdown
  }), !loading && /*#__PURE__*/React.createElement(FadeIn, {
    initialPose: "exit",
    pose: isOpen ? 'enter' : 'exit'
  }, /*#__PURE__*/React.createElement(Menu, {
    onClick: toggleDropdown,
    hasArrow: hasArrow
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(DropdownItem, {
      key: option,
      label: option,
      onClick: handleItemClick(option),
      selected: equals(selectedOption, option)
    });
  }))));
};

var Dropdown = enhance(DropdownComponent);
export { Dropdown, DropdownComponent, enhance };